import { forwardRef, type SelectHTMLAttributes } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

export type DropdownSelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/**
 * DropdownSelect — native <select> wrapped in v7 styling.
 *
 * Source: .planning/v7-design-handoff/v7-sla/shell.jsx lines 292-301
 *
 * Uses `appearance-none` to suppress the native chevron and overlays a
 * heroicons chevron with `pointer-events-none` so the underlying select
 * still receives keyboard + click. Caller passes <option> children.
 */
export const DropdownSelect = forwardRef<HTMLSelectElement, DropdownSelectProps>(
  ({ className = '', children, ...props }, ref) => (
    <span className={`relative inline-flex items-center ${className}`}>
      <select
        ref={ref}
        // MKS-493 — `rounded-ms-control` defaults to the `rounded-md` it
        // replaces; Sparkle lifts selects to 12px alongside text inputs.
        className="ms-input appearance-none pr-8 pl-3 py-2 bg-white border border-ms-border rounded-ms-control text-[12.5px] text-ms-text-strong focus:outline-none focus:ring-2 focus:ring-ms-orange/40"
        {...props}
      >
        {children}
      </select>
      <ChevronDownIcon className="w-4 h-4 absolute right-2 pointer-events-none text-ms-text-muted" />
    </span>
  )
);
DropdownSelect.displayName = 'DropdownSelect';
